import { IAppState } from '../../redux';

export const selectIsMultiPostingAvailable = (state: IAppState) => {
  const { publishTerms } = state;

  return publishTerms.isMultipostingAvailable;
};
